<template>
  <div class="home">
    <HomeBanner
      :bannerList="homeData.bannerList"
      @go-training-notice="handleGoTrainingNotice"
      @go-info-news="handleGoInfoNews"
    />

    <HomeQuickNav
      @go-reg-process="handleGoRegProcess"
      @go-rules="handleGoRules"
    />

    <div class="main-content">
      <HomeTrainingList
        :yearList="yearList"
        :selectedYear="selectedYear"
        :trainingMap="trainingMap"
        :userInfo="curUser"
        :loading="loadingTraining"
        @year-change="handleYearChange"
        @enroll="handleEnroll"
        @detail="handleDetail"
      />
    </div>
  </div>
</template>

<script>
import HomeBanner from "./components/HomeBanner.vue";
import HomeQuickNav from "./components/HomeQuickNav.vue";
import HomeTrainingList from "./components/HomeTrainingList.vue";
import { httpRequest } from "@/axios/axios-api";

export default {
  name: "Home",
  components: {
    HomeBanner,
    HomeQuickNav,
    HomeTrainingList
  },
  data() {
    return {
      homeData: {
        bannerList: [],
        liveList: [],
        categoryList: [],
        user: null
      },
      curUser: null,
      yearList: [],
      selectedYear: new Date().getFullYear(),
      loadingTraining: false,
      trainingMap: {
        0: [],
        1: [],
        2: [],
        3: []
      }
    };
  },
  created() {
    this.initYearList();
    this.loadInitialData();
  },
  methods: {
    initYearList() {
      const currentYear = new Date().getFullYear();
      this.yearList = [];
      if (currentYear >= 2020) {
        for (let i = currentYear; i >= 2020; i--) {
          this.yearList.push(i);
        }
      } else {
        for (let i = currentYear; i <= 2020; i++) {
          this.yearList.push(i);
        }
      }
      this.selectedYear = this.yearList[0];
    },
    async loadInitialData() {
      await Promise.all([this.loadHomeData(), this.loadUserInfo()]);
      await this.loadTrainingDataForYear(this.selectedYear);
    },
    async loadHomeData() {
      const res = await httpRequest("/app/pc/data/home", "get", null);
      if (res && res.code === 200) {
        this.homeData = res.data || this.homeData;
        if (res.data && res.data.user) {
          this.curUser = res.data.user;
          localStorage.setItem("pc_user", JSON.stringify(res.data.user));
        }
      }
    },
    async loadUserInfo() {
      const res = await httpRequest("/app/user", "get", null);
      if (res && res.code === 200) {
        this.curUser = res.data;
        localStorage.setItem("pc_user", JSON.stringify(res.data));
      }
    },
    async loadTrainingDataForYear(year) {
      this.loadingTraining = true;
      const majorTypes = [0, 1, 2, 3];
      try {
        const requests = majorTypes.map(majorType =>
          httpRequest("/app/exam/exam/can-enroll-exams", "get", {
            majorType,
            year
          })
        );
        const responses = await Promise.all(requests);
        const newMap = { 0: [], 1: [], 2: [], 3: [] };
        responses.forEach((res, idx) => {
          const majorType = majorTypes[idx];
          if (res && res.code === 200 && Array.isArray(res.data)) {
            newMap[majorType] = res.data;
          }
        });
        this.trainingMap = newMap;
      } finally {
        this.loadingTraining = false;
      }
    },
    async handleYearChange(year) {
      if (year === this.selectedYear) {
        return;
      }
      this.selectedYear = year;
      await this.loadTrainingDataForYear(this.selectedYear);
    },
    handleEnroll(row) {
      if (!this.curUser) {
        this.$message.warning("请先登录");
        this.$router.push("/login");
        return;
      }
      this.$router.push({
        path: "/registrationDetails",
        query: {
          erId: row.erId,
          isXQ: "0"
        }
      });
    },
    handleDetail(row) {
      this.$router.push({
        path: "/registrationDetails",
        query: {
          erId: row.erId,
          isXQ: "1"
        }
      });
    },
    handleGoTrainingNotice() {
      this.$router.push({
        path: "/trainNotice",
        query: {
          modelType: "1"
        }
      });
    },
    handleGoInfoNews() {
      this.$router.push({
        path: "/trainNotice",
        query: {
          modelType: "0"
        }
      });
    },
    handleGoRegProcess() {
      this.$router.push({
        path: "/news",
        query: {
          type: "bmlc"
        }
      });
    },
    handleGoRules() {
      this.$router.push({
        path: "/news",
        query: {
          type: "pxglgd"
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.home {
  min-height: 100vh;
  background-color: #f2f4f8;
  padding-top: 20px;
  padding-bottom: 40px;

  .main-content {
    width: 1200px;
    margin: 0 auto;
  }
}
</style>
